import React from "react";
import { useBookmarksContext } from "@/context/BookmarksProvider";
import { Star } from "lucide-react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

const TapBookmark = ({ tool, size }) => {
  const { push } = useRouter();
  const { bookmarks, getBookmarksTools } = useBookmarksContext();

  const isBookmark = bookmarks.some((item) => item._id === tool._id);

  const handleBookmark = () => {
    if (!isBookmark) getBookmarksTools(tool);
    push(`/bookmarks#${tool._id}`);
    toast.success("Bookmark added!");
  };

  return (
    <div
      onClick={handleBookmark}
      className="cursor-pointer color_black pb-2 sm:pb-0"
    >
      <Star size={size} strokeWidth={2} fill={isBookmark ? "black" : "none"} />
    </div>
  );
};

export default TapBookmark;
